import * as React from "react";
import { connect } from "react-redux";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { CollectiveInvoice } from "../../../../../store/CollectiveInvoice/Types";
import { ThemeBreakpoints, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalClose } from "../../../../../utils/redux/ActionTypes";
import { Detail } from "../collective-invoice/Detail";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";

/**
 *
 */
interface OwnProps {
    modalID: string;
    invoice: CollectiveInvoice;
}

interface StateProps {
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps & StateProps;


/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
});

/**
 *
 */
export class DetailModalComp
    extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    public render() {
        return (
            <FlexColumn
            >
                <FlexRow isFixed>
                    <Navbar
                        theme={{
                            palette: ThemePalette.CONTRAST_TERTIARY,
                        }}
                    >
                        <NavbarStack>
                            <NavbarStackContent>
                                <NavbarTitle>
                                    Collective invoice audit trail log
                                </NavbarTitle>
                            </NavbarStackContent>
                            <NavbarStackRight>
                                <NavbarIcon>
                                    <Button  icon={IconNames.TIMES}
                                        link={{ onClick: this.closeModal() }}
                                    />
                                </NavbarIcon>
                            </NavbarStackRight>
                        </NavbarStack>
                    </Navbar>
                </FlexRow>
                <FlexRow
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                    }}
                >
                    <FlexColumn
                        style={{
                            maxHeight: "calc(98vh - 120px)",
                        }}>
                        <FlexRow isScrollable >
                            <div style={{width: "100%"}}>
                                <Container
                                    theme={{
                                        padding: {
                                            "": { y: 3 },
                                            "sm": { y: 4 },
                                        },
                                    }}
                                >
                                    <Detail details={this.props.invoice} />
                                </Container>
                            </div>
                        </FlexRow>
                        <FlexRow isFixed>
                            <FlexColumn
                                theme={{
                                    palette: ThemePalette.CONTRAST_SECONDARY,
                                }}
                            >
                                <Container
                                    theme={{
                                        padding: { "": { y: 3 } },
                                    }}
                                >
                                    <ButtonsWrapper
                                        defaultOrientation={Orientation.HORIZONTAL}
                                        orientations={{
                                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                        }}
                                        alignment={Alignment.RIGHT}
                                    >
                                        <Button
                                            theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                            link={{ onClick: this.closeModal() }}
                                        >
                                            Close
                                        </Button>
                                    </ButtonsWrapper>
                                </Container>
                            </FlexColumn>
                        </FlexRow>
                    </FlexColumn>
                </FlexRow>
            </FlexColumn>
        );
    }

    private closeModal() {
        return () => this.props.closeModal(this.props.modalID);
    }
}

/**
 *
 */
export const DetailModal = connect(
    undefined,
    mapDispatchToProps,
)(DetailModalComp);
